export enum MathItemColorClass {
	FUNCTION = 'math-function',
	ATTRIBUTE = 'math-attribute',
	AGGREGATION = 'math-aggregation',
	PREDEFINED_METRIC = 'math-predefined-metric',
	CUSTOM_METRIC = 'math-custom-metric',
	SCORECARD_METRIC = 'math-scorecard-metric',
	HIERARCHY_METRIC = 'math-hierarchy-metric'
}
